import { useQuery } from 'react-query';
import { useLanguage } from 'src/common/hooks';
import { client } from './api-client';

export interface BranchTag {
  name: string;
  description: string;
}

export const useBranches = () => {
  const language = useLanguage();
  const query = useQuery(
    ['branches', language],
    () => client.get<BranchTag[]>('/web/branches', {}).then((res) => res.data),
    {
      staleTime: 1000 * 60 * 5, // 5 minutes
      cacheTime: 1000 * 60 * 10, // 10 minutes
    }
  );

  const branches = query.data || [];
  return {
    branches,
    ...query,
  };
};

// Country is nullable: a branch can still be in the "Bez kraju" bucket
// (no country assigned yet) during rollout -- treat that as valid, not an
// error state.
export interface BranchTagWithCountry {
  name: string;
  description: string;
  country_code: string | null;
  country_name: string | null;
}

export const useBranchesWithCountry = () => {
  const language = useLanguage();
  const query = useQuery(
    ['branches-with-country', language],
    () =>
      client
        .get<BranchTagWithCountry[]>('/web/branches-with-country', {})
        .then((res) => res.data),
    {
      staleTime: 1000 * 60 * 5, // 5 minutes
      cacheTime: 1000 * 60 * 10, // 10 minutes
    }
  );

  const branches = query.data || [];
  return {
    branches,
    ...query,
  };
};
